export const BUILDINGS_BUILDING_LOAD_SUCCESS =
  'BUILDINGS_BUILDING_LOAD_SUCCESS';
export const BUILDINGS_BUILDING_WORK_ORDERS_LOAD_SUCCESS =
  'BUILDINGS_BUILDING_WORK_ORDERS_LOAD_SUCCESS';
export const BUILDINGS_BUILDING_WORK_ORDERS_PAGE_CHANGE =
  'BUILDINGS_BUILDING_WORK_ORDERS_PAGE_CHANGE';
export const BUILDINGS_BUILDING_PROJECTS_LOAD_SUCCESS =
  'BUILDINGS_BUILDING_PROJECTS_LOAD_SUCCESS';
export const BUILDINGS_BUILDING_CLIENTS_LOAD_SUCCESS =
  'BUILDINGS_BUILDING_CLIENTS_LOAD_SUCCESS';
export const BUILDINGS_EDIT_FORM_LOAD_FROM_CURRENT =
  'BUILDINGS_EDIT_FORM_LOAD_FROM_CURRENT';
export const BUILDINGS_LOAD_SUCCESS = 'BUILDINGS_LOAD_SUCCESS';
export const BUILDINGS_NEW_CLEAR_DATA = 'BUILDINGS_NEW_CLEAR_DATA';
export const BUILDINGS_NEW_CLIENT_REMOVE = 'BUILDINGS_NEW_CLIENT_REMOVE';
export const BUILDINGS_NEW_CLIENT_SELECT = 'BUILDINGS_NEW_CLIENT_SELECT';
export const BUILDINGS_NEW_CONTRACTOR_REMOVE =
  'BUILDINGS_NEW_CONTRACTOR_REMOVE';
export const BUILDINGS_NEW_CONTRACTOR_SELECT =
  'BUILDINGS_NEW_CONTRACTOR_SELECT';
export const BUILDINGS_NEW_ENGINEER_ADD = 'BUILDINGS_NEW_ENGINEER_ADD';
export const BUILDINGS_NEW_FILES_ADD = 'BUILDINGS_NEW_FILES_ADD';
export const BUILDINGS_NEW_FILE_REMOVE = 'BUILDINGS_NEW_FILE_REMOVE';
export const BUILDINGS_NEW_FORM_INVALID = 'BUILDINGS_NEW_FORM_INVALID';
export const BUILDINGS_NEW_FORM_VALID = 'BUILDINGS_NEW_FORM_VALID';
export const BUILDINGS_NEW_FORM_VALUE_CHANGE =
  'BUILDINGS_NEW_FORM_VALUE_CHANGE';
export const BUILDINGS_NEW_UNIONS_LOAD_SUCCESS =
  'BUILDINGS_NEW_UNIONS_LOAD_SUCCESS';
export const BUILDINGS_NEW_PARKING_ON_SITE_SELECT =
  'BUILDINGS_NEW_PARKING_ON_SITE_SELECT';
export const BUILDINGS_NEW_UNIONS_SELECT = 'BUILDINGS_NEW_UNIONS_SELECT';
export const BUILDINGS_SET_PAGINATION_DATA = 'BUILDINGS_SET_PAGINATION_DATA';



// WEBPACK FOOTER //
// ./src/actions/admin/buildings/action-types.js